<template>
    <div>
      <subsystem-tree
        v-if="tenant"
        class="subsystem-tree__data"
        :key="tenant.id"
        :unit.sync="tenant"
        :mode="TreeMode"
        :role="role"
        :data-cy="`tenant-container-${tenant.id}-${tenant.name ? tenant.name.replace(/\s+/g, '-').toLowerCase() : 'unnamed'}`"
        @toggle-item="onToggleItem"
      />
    </div>
  </template>

  <script>
  import store from "@/store";
  import {
    BTable,
    BPagination,
    BModal,
    BTooltip,
    BDropdown,
    BDropdownItem,
  } from "bootstrap-vue";
  import SubsystemTree from "../components/SubsystemTree";
  import { decryptData } from "@/utils/decryptUserDataUtils";

  export default {
    name: "FacilitiesWidget",
    props: {
      tenant: Object,
      idTenant: String | Number,
      totalUnits: Number,
      filter: {
        type: Array,
        default: []
      },
      TreeMode: {
        type: String,
        default: "widget",
      },
      role: {
        type: String,
        default: "disabled",
      },
      parentOpened: {
        type: Boolean,
      },
    },
    components: {
      BTable,
      BPagination,
      BModal,
      BTooltip,
      BDropdown,
      BDropdownItem,
      SubsystemTree,
    },
    data() {
      return {
        fields: [
          {
            key: "description",
            label: "grid.widgets.units.table.rows.1",
          },
        ],
        recordsPerPage: [5, 10, 25, 50, 100],
        idUnit: null,
        perPage: 25,
        currentPage: 1,
        isBusy: false,
        pagination: {
          first: null,
          last: null,
          next: null,
          prev: null,
        },
        user: JSON.parse(decryptData(window.localStorage.userData)),
      };
    },
    computed: {
      getTotalUnits() {
        let total = store.getters["grid/getTotalUnits"]({
          idUnit: this.idUnit,
          idTenant: this.idTenant,
          filter: this.filter,
        });
        this.$emit("update:totalUnits", total);
        return total;
      },
      items() {
        if (this.loadingUnitsStatus)
          return null;

        let parsedItems = [];

        let facilities = store.getters["grid/getUnits"]({
          idUnit: this.idUnit,
          idTenant: this.idTenant,
          filter: this.filter,
          currentPage: this.currentPage,
          perPage: this.perPage
        });

        facilities.forEach(facility => {
          parsedItems.push([{
            ...facility,
            ...facility.subsystem_tree[0],
          }])
        });

        let items = {
          icon: 'feather icon-box',
          id: this.tenant.id,
          tag: 'tenant',
          text: this.tenant.name,
          type: 'parent',
          children: parsedItems
        };

        return items;
      },
      loadingUnitsStatus() {
        return store.state.grid.loadingUnits;
      },
      totalPages() {
        return Math.ceil(this.getTotalUnits / this.perPage);
      },
      sidebarMinWidthReached() {
        return store.getters["grid/sidebarMinWidthReached"];
      },
      treeConfig() {
        const config = store.getters["grid/getTreeById"](this.idTenant);
        return config
          ? config.children.reduce((acc, item) => {
              acc[item.unitId] = item.open;
              return acc;
            }, {})
          : null;
      },
    },
    methods: {
      clickPaginationBtn(direction) {
        if (direction === "prev") {
          if (this.currentPage - 1 > 0) {
            this.currentPage--;
          }
        } else {
          if (this.currentPage + 1 <= this.totalPages) {
            this.currentPage++;
          }
        }
      },
      onUnitClick({ item }) {
        const selectedUnit = item;

        this.$http.get(selectedUnit.cameras_link).then((resp) => {
          store.dispatch("grid/showLayoutModal", {
            source: "unit",
            data: {
              obj: selectedUnit,
              cameras: resp.data.data,
            },
          });
        });

        this.$root.$emit("bv::show::modal", "layout_modal");
      },
      onToggleItem(data) {
        // const { item, unit } = data;

        // // TODO: Improve this code
        // if (item.children.length === 5) {
        //   const payload = {
        //     tenantId: this.idTenant,
        //     unitId: unit.id,
        //     open: item.opened,
        //     entity: "unit",
        //   };
        //   store.dispatch("grid/updateTree", payload);
        // }
      },
      resetDataModal() {
        this.dataModal.data = {};
      },
      onChangeRecordesPerPage(val) {
        this.perPage = val.target.value;
      },
    },
  };
  </script>
